/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './Flickr.scss';
import logoUrl from '../../components/Header/logo.svg';
import image01 from './image01.jpg';
import image02 from './image02.jpg';
import image03 from './image03.jpg';
import image04 from './image04.jpg';
import image05 from './image05.jpg';
import image06 from './image06.jpg';
import image07 from './image07.jpg';

class Flickr extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.content}>
            <img
              src={logoUrl}
              width="101"
              height="111"
              alt="Water is a Human Right"
            />
            <p className={s.text}>
              In Europe<br />1 Million people have no water access<br />8
              Millions people have no sanitation
            </p>
            <div>
              View all pictures on{' '}
              <a
                className={cx(s.moreLink, s.external)}
                href="https://www.flickr.com/photos/94657608@N02/collections/72157697758214351/"
              >
                Flickr
              </a>
            </div>
          </div>

          <div className={cx(s.gallery, s.galleryLeft)}>
            <svg width="250" height="273" viewBox="0 0 250 273">
              <defs>
                <mask id="svg-mask1">
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M303.270142,329.234375 C329.172486,329.234375 418.53772,276.669922 444.158814,197.390625 C469.779908,118.111328 401.264283,55.8789063 343.06897,55.8789063 C284.873658,55.8789063 207.627564,79.1699219 200.408814,155.498047 C193.190064,231.826172 277.367798,329.234375 303.270142,329.234375 Z"
                    transform="rotate(180 225.33 165.057)"
                  />
                </mask>
              </defs>
              <image
                mask="url(#svg-mask1)"
                href={image01}
                width="250"
                height="273"
              />
            </svg>

            <svg width="87" height="123" viewBox="0 0 87 123">
              <defs>
                <mask id="svg-mask2">
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M154.191406,421.078125 C198.568359,422.430664 203.499023,388.677057 203.499023,367.298828 C203.499023,352.499023 180.494141,300.652344 173.332031,300.652344 C166.169922,300.652344 131.517578,331.554688 123.109375,349.527344 C110.895152,375.635424 109.814453,419.725586 154.191406,421.078125 Z"
                    transform="rotate(-14 -1117.907 700.046)"
                  />
                </mask>
              </defs>
              <image
                mask="url(#svg-mask2)"
                href={image02}
                width="87"
                height="123"
              />
            </svg>

            <svg width="219" height="267" viewBox="0 0 219 267">
              <defs>
                <mask id="svg-mask3">
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M270.095032,610.285481 C327.344279,631.884303 418.093277,594.807746 411.573383,508.308411 C405.053489,421.809077 368.030511,395.998269 307.753002,396.95746 C247.475493,397.916651 140.360148,488.843735 140.598511,499.598546 C140.836873,510.353357 212.845785,588.68666 270.095032,610.285481 Z"
                    transform="rotate(100 352.664 252.072)"
                  />
                </mask>
              </defs>
              <g fill="none" fillRule="evenodd" transform="translate(-93 -352)">
                <use fill="#ffffff" transform="rotate(180 239.155 454.742)" />
              </g>
              <image
                mask="url(#svg-mask3)"
                href={image03}
                width="217"
                height="267"
              />
            </svg>
          </div>

          <div className={cx(s.gallery, s.galleryRight)}>
            <svg width="214" height="258" viewBox="0 0 214 258">
              <defs>
                <mask id="svg-mask4">
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M1362.46172,242.360772 C1417.60426,234.218738 1458.20935,161.589127 1440.8889,98.3636183 C1423.56845,35.1381093 1345.34958,23.1291458 1304.81914,35.4216735 C1264.28871,47.7142012 1178.9661,121.093488 1186.23745,169.871878 C1193.5088,218.650267 1307.31917,250.502806 1362.46172,242.360772 Z"
                    transform="rotate(86 715.192 -515.908)"
                  />
                </mask>
              </defs>
              <g fill="none" fillRule="evenodd" transform="translate(-1090)">
                <use fill="#ffffff" transform="rotate(180 1236.477 103.519)" />
              </g>
              <image
                mask="url(#svg-mask4)"
                href={image04}
                width="212"
                height="257"
              />
            </svg>

            <svg width="158" height="185" viewBox="0 0 158 185">
              <defs>
                <mask id="svg-mask5">
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M1189.92969,447.136507 C1229.26937,445.260681 1272.93748,415.222404 1262.04574,363.550139 C1251.154,311.877875 1211.7801,286.630434 1173.80746,290.247229 C1135.83483,293.864024 1069.89986,374.96672 1079.59869,397.815736 C1089.29752,420.664752 1150.59001,449.012333 1189.92969,447.136507 Z"
                    transform="rotate(113 718.205 -126.838)"
                  />
                </mask>
              </defs>
              <image
                mask="url(#svg-mask5)"
                href={image05}
                width="158"
                height="184"
              />
            </svg>

            <svg width="130" height="153" viewBox="0 0 130 153">
              <defs>
                <mask id="svg-mask7">
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M1260.50888,631.632812 C1297.96982,637.359375 1336.93076,608.039899 1342.28232,580.015625 C1347.63388,551.991351 1325.54122,480 1295.81371,480 C1266.08619,480 1230.90229,518.414078 1217.68778,551.991351 C1204.47327,585.568624 1223.04794,625.90625 1260.50888,631.632812 Z"
                    transform="matrix(-1 0 0 1 1343.528 -480)"
                  />
                </mask>
              </defs>
              <image
                mask="url(#svg-mask7)"
                href={image07}
                width="130"
                height="153"
              />
            </svg>

            <svg width="171" height="222" viewBox="0 0 171 222">
              <defs>
                <mask id="svg-mask6">
                  <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M1378.83297,480.952335 C1417.80531,495.344709 1498.55993,480.569355 1499.57928,417.942855 C1500.59864,355.316354 1461.92222,318.6963 1420.07222,315.57727 C1378.22221,312.45824 1274.49518,355.568763 1273.56779,390.977094 C1272.64039,426.385425 1339.86063,466.559962 1378.83297,480.952335 Z"
                    transform="scale(1 -1) rotate(-80 428.82 923.215)"
                  />
                </mask>
              </defs>
              <image
                mask="url(#svg-mask6)"
                href={image06}
                width="171"
                height="222"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Flickr);
